import { useCheckAccountTraits } from '@cmg/auth';
import { Alert, AlertTitle, Link, Stack, Tooltip, Typography } from '@cmg/design-system';
import React from 'react';

import {
  OrderBookPersonaType,
  useIdentifyOrderBookPersona,
} from '../../../hooks/useIdentifyOrderBookPersona';
import { useComplianceContext } from '../../context/ComplianceContext';

export type Props = {
  offeringId: string;
  isCertificatesVisibleForOffering?: boolean;
};

const ComplianceInfo: React.FC<Props> = ({ offeringId, isCertificatesVisibleForOffering }) => {
  const hasCertificateLibraryTrait = useCheckAccountTraits(['CERTIFICATE_LIBRARY']);
  const { type } = useIdentifyOrderBookPersona({ offeringId });
  const { warning } = useComplianceContext().certificates;

  const hoverContent = `If certificates are not on file or expired, provide the associated Action link to the investor to complete. 
    Certificates become eligible typically within five minutes of submission, but may take up to one business day.`;

  if (
    !hasCertificateLibraryTrait &&
    isCertificatesVisibleForOffering &&
    type !== OrderBookPersonaType.BUY_SIDE
  ) {
    return null;
  }

  return (
    <Stack gap={1}>
      <Typography variant="body1">
        Participation in this offering requires the following eligible certificates.{' '}
        {type !== OrderBookPersonaType.BUY_SIDE && (
          <Tooltip title={hoverContent} variant="info" placement="top" aria-label="get more info">
            <Link>More info</Link>
          </Tooltip>
        )}
      </Typography>
      {type === OrderBookPersonaType.BUY_SIDE && warning.hasComplianceWarning && (
        <Alert severity="info">
          <AlertTitle>Certificate not on file or expired</AlertTitle>
          <Typography>
            Click Copy link to submit valid certificates via the provided link. Certificates become
            eligible typically within five minutes of submission, but may take up to one business
            day. For support, contact <a href="mailto:support@cmgx.io">CMG support</a>.
          </Typography>
        </Alert>
      )}
    </Stack>
  );
};

export default ComplianceInfo;
